"use strict";
// Generated by robots, do not change this manually!
Object.defineProperty(exports, "__esModule", { value: true });
exports.dark = void 0;
exports.dark = {
    ":root": {
        "--plasma-colors-white": "rgba(255, 255, 255, 0.96)",
        "--plasma-colors-white-primary": "rgba(255, 255, 255, 0.96)",
        "--plasma-colors-white-secondary": "rgba(255, 255, 255, 0.56)",
        "--plasma-colors-white-tertiary": "rgba(255, 255, 255, 0.28)",
        "--plasma-colors-black": "#080808",
        "--plasma-colors-black-primary": "#080808",
        "--plasma-colors-black-secondary": "rgba(8, 8, 8, 0.56)",
        "--plasma-colors-black-tertiary": "rgba(8, 8, 8, 0.28)",
        "--plasma-colors-dark01": "#171717",
        "--plasma-colors-dark02": "#232323",
        "--plasma-colors-dark03": "#363636",
        "--plasma-colors-transparent": "rgba(0, 0, 0, 0)",
        "--plasma-colors-button-clear": "rgba(0, 0, 0, 0)",
        "--plasma-colors-button-black": "#080808",
        "--plasma-colors-button-black-secondary": "rgba(8, 8, 8, 0.12)",
        "--plasma-colors-button-black-transparent": "rgba(8, 8, 8, 0.56)",
        "--plasma-colors-button-white": "#FFFFFF",
        "--plasma-colors-button-white-secondary": "rgba(255, 255, 255, 0.12)",
        "--plasma-colors-text": "rgba(255, 255, 255, 0.96)",
        "--plasma-colors-link": "#3F81FD",
        "--plasma-colors-link-hover": "#6298FD",
        "--plasma-colors-link-active": "#1767FD",
        "--plasma-colors-link-visited": "#5993FF",
        "--plasma-colors-link-visited-hover": "#7DAAFF",
        "--plasma-colors-link-visited-active": "#3078FF",
        "--plasma-colors-primary": "rgba(255, 255, 255, 0.96)",
        "--plasma-colors-secondary": "rgba(255, 255, 255, 0.56)",
        "--plasma-colors-tertiary": "rgba(255, 255, 255, 0.28)",
        "--plasma-colors-paragraph": "rgba(255, 255, 255, 0.96)",
        "--plasma-colors-inverse": "#080808",
        "--plasma-colors-background": "#080808",
        "--plasma-colors-background-primary": "#171717",
        "--plasma-colors-background-secondary": "#232323",
        "--plasma-colors-background-tertiary": "#363636",
        "--plasma-colors-input-border": "rgba(0, 0, 0, 0)",
        "--plasma-colors-input-border-hover": "rgba(0, 0, 0, 0)",
        "--plasma-colors-input-border-focus": "rgba(0, 0, 0, 0)",
        "--plasma-colors-input-error-background": "rgba(255, 46, 67, 0.12)",
        "--plasma-colors-accent": "#5993FF",
        "--plasma-colors-success": "#24B23E",
        "--plasma-colors-warning": "#FA6D20",
        "--plasma-colors-critical": "#FF4D5F",
        "--plasma-colors-surface-liquid01": "rgba(255, 255, 255, 0.06)",
        "--plasma-colors-surface-liquid02": "rgba(255, 255, 255, 0.12)",
        "--plasma-colors-surface-liquid03": "rgba(255, 255, 255, 0.2)",
        "--plasma-colors-surface-solid01": "#171717",
        "--plasma-colors-surface-solid02": "#232323",
        "--plasma-colors-surface-solid03": "#363636",
        "--plasma-colors-surface-card": "rgba(255, 255, 255, 0.12)",
        "--plasma-colors-button-primary": "#3F82FD",
        "--plasma-colors-button-primary-hover": "#538efe",
        "--plasma-colors-button-primary-active": "#3a75e5",
        "--plasma-colors-button-secondary": "rgba(255, 255, 255, 0.12)",
        "--plasma-colors-button-secondary-hover": "rgba(255, 255, 255, 0.16)",
        "--plasma-colors-button-secondary-active": "rgba(255, 255, 255, 0.1)",
        "--plasma-colors-button-accent": "#3F82FD",
        "--plasma-colors-button-success": "#21A038",
        "--plasma-colors-button-success-transparent": "rgba(33, 160, 56, 0.3)",
        "--plasma-colors-button-success-hover": "#3eaa4d",
        "--plasma-colors-button-success-active": "#1d9233",
        "--plasma-colors-button-success-active-transparent": "rgba(97, 181, 103, 0.384)",
        "--plasma-colors-button-warning": "#E35502",
        "--plasma-colors-button-warning-transparent": "rgba(227, 85, 2, 0.3)",
        "--plasma-colors-button-warning-hover": "#f76d2f",
        "--plasma-colors-button-warning-active": "#de550a",
        "--plasma-colors-button-warning-active-transparent": "rgba(238, 127, 83, 0.384)",
        "--plasma-colors-button-critical": "#FF2E43",
        "--plasma-colors-button-critical-transparent": "rgba(255, 46, 67, 0.3)",
        "--plasma-colors-button-critical-hover": "#ff4757",
        "--plasma-colors-button-critical-active": "#e82a3e",
        "--plasma-colors-button-critical-active-transparent": "rgba(255, 114, 113, 0.384)",
        "--plasma-colors-button-checked": "#FFFFFF",
        "--plasma-colors-button-checked-hover": "#FFFFFF",
        "--plasma-colors-button-checked-hover-color": "hsla(0, 0%, 3.1372549019607843%, 1)",
        "--plasma-colors-button-checked-active": "#FFFFFF",
        "--plasma-colors-button-checked-active-color": "hsla(0, 0%, 3.1372549019607843%, 1)",
        "--plasma-colors-button-focused": "#3F82FD",
        "--plasma-colors-gradient": "linear-gradient(45deg, hsla(220.1123595505618, 85.57692307692307%, 59.21568627450981%, 1) 0%, hsla(189.78947368421052, 78.51239669421487%, 52.54901960784314%, 1) 100%)",
        "--plasma-colors-gradient-device": "",
        "--plasma-colors-voice-phrase-gradient": "",
        "--plasma-colors-skeleton-gradient": "linear-gradient( 90deg, rgba(255, 255, 255, 0.09) 0%, rgba(255, 255, 255, 0.08) 6.25%, rgba(255, 255, 255, 0.05) 12.5%, rgba(255, 255, 255, 0.01) 25%, rgba(255, 255, 255, 0.05) 37.5%, rgba(255, 255, 255, 0.08) 43.75%, rgba(255, 255, 255, 0.09) 50%, rgba(255, 255, 255, 0.08) 56.25%, rgba(255, 255, 255, 0.05) 62.5%, rgba(255, 255, 255, 0.01) 75%, rgba(255, 255, 255, 0.05) 87.5%, rgba(255, 255, 255, 0.08) 93.75%, rgba(255, 255, 255, 0.09) 100% )",
        "--plasma-colors-skeleton-gradient-lighter": "linear-gradient( 90deg, rgba(255, 255, 255, 0.36) 0%, rgba(255, 255, 255, 0.32) 6.25%, rgba(255, 255, 255, 0.20) 12.5%, rgba(255, 255, 255, 0.04) 25%, rgba(255, 255, 255, 0.20) 37.5%, rgba(255, 255, 255, 0.32) 43.75%, rgba(255, 255, 255, 0.36) 50%, rgba(255, 255, 255, 0.08) 56.25%, rgba(255, 255, 255, 0.20) 62.5%, rgba(255, 255, 255, 0.04) 75%, rgba(255, 255, 255, 0.20) 87.5%, rgba(255, 255, 255, 0.32) 93.75%, rgba(255, 255, 255, 0.36) 100% )",
        "--plasma-colors-speech-bubble-sent": "",
        "--plasma-colors-speech-bubble-received": "",
        "--plasma-colors-overlay": "rgba(0, 0, 0, 0.8)",
        "--plasma-colors-overlay-soft": "rgba(8, 8, 8, 0.56)",
        "--plasma-colors-overlay-hard": "rgba(8, 8, 8, 0.9)",
        "--plasma-colors-overlay-blur": "rgba(23, 23, 23, 0.28)",
        "--plasma-colors-dark-overlay-soft": "rgba(8, 8, 8, 0.56)",
        "--plasma-colors-dark-overlay-hard": "rgba(8, 8, 8, 0.9)",
        "--plasma-colors-dark-overlay-blur": "rgba(23, 23, 23, 0.28)",
        "--plasma-colors-light-overlay-soft": "rgba(8, 8, 8, 0.56)",
        "--plasma-colors-light-overlay-hard": "rgba(8, 8, 8, 0.9)",
        "--plasma-colors-light-overlay-blur": "rgba(23, 23, 23, 0.28)",
        "--plasma-colors-inverse-overlay-soft": "rgba(8, 8, 8, 0.56)",
        "--plasma-colors-inverse-overlay-hard": "rgba(8, 8, 8, 0.9)",
        "--plasma-colors-inverse-overlay-blur": "rgba(23, 23, 23, 0.28)",
        "--plasma-outline-size": "0.125rem",
        "--plasma-button-l-height": "3.5rem",
        "--plasma-button-l-padding-y": "1rem",
        "--plasma-button-l-padding-x": "1.625rem",
        "--plasma-button-l-padding-content-x": "1.625rem",
        "--plasma-button-l-padding-stretch-x": "1.25rem",
        "--plasma-button-l-radius": "1rem",
        "--plasma-button-l-radius-circle": "1.75rem",
        "--plasma-button-m-height": "3rem",
        "--plasma-button-m-padding-y": "0.75rem",
        "--plasma-button-m-padding-x": "1.375rem",
        "--plasma-button-m-padding-content-x": "1.5rem",
        "--plasma-button-m-padding-stretch-x": "1.25rem",
        "--plasma-button-m-radius": "0.75rem",
        "--plasma-button-m-radius-circle": "1.5rem",
        "--plasma-button-s-height": "2.5rem",
        "--plasma-button-s-padding-y": "0.5rem",
        "--plasma-button-s-padding-x": "1.125rem",
        "--plasma-button-s-padding-content-x": "1.25rem",
        "--plasma-button-s-padding-stretch-x": "1.25rem",
        "--plasma-button-s-radius": "0.75rem",
        "--plasma-button-s-radius-circle": "1.25rem",
        "--plasma-field-helper-text-margin-top": "0.25rem",
        "--plasma-field-helper-text-font-family": "var(--plasma-typo-text-xs-font-family)",
        "--plasma-field-helper-text-font-size": "var(--plasma-typo-text-xs-font-size)",
        "--plasma-field-helper-text-font-style": "var(--plasma-typo-text-xs-font-style)",
        "--plasma-field-helper-text-font-weight": "var(--plasma-typo-text-xs-bold-font-weight)",
        "--plasma-field-helper-text-letter-spacing": "var(--plasma-typo-text-xs-letter-spacing)",
        "--plasma-field-helper-text-line-height": "var(--plasma-typo-text-xs-line-height)",
        "--plasma-field-label-margin-bottom": "0.75rem",
        "--plasma-field-label-color": "var(--plasma-colors-primary)",
        "--plasma-field-content-margin": "1rem",
        "--plasma-input-border-width": "1px",
        "--plasma-input-border-radius": "0.75rem",
        "--plasma-input-l-height": "3rem",
        "--plasma-input-l-padding-y": "0.75rem",
        "--plasma-input-l-padding-x": "1rem",
        "--plasma-input-l-has-label-padding-top": "1.4375rem",
        "--plasma-input-l-has-label-padding-bottom": "0.4375rem",
        "--plasma-input-l-has-content-padding-left": "3.25rem",
        "--plasma-input-l-has-content-padding-right": "3.25rem",
        "--plasma-input-m-height": "2.5rem",
        "--plasma-input-m-padding-y": "0.5rem",
        "--plasma-input-m-padding-x": "1rem",
        "--plasma-input-m-has-content-padding-left": "3.25rem",
        "--plasma-input-m-has-content-padding-right": "3.25rem",
        "--plasma-input-s-height": "2rem",
        "--plasma-input-s-padding-y": "0.25rem",
        "--plasma-input-s-padding-x": "1rem",
        "--plasma-input-s-has-content-padding-left": "3.25rem",
        "--plasma-input-s-has-content-padding-right": "3.25rem",
        "--plasma-input-font-family": "var(--plasma-typo-body-s-font-family)",
        "--plasma-input-font-size": "var(--plasma-typo-body-s-font-size)",
        "--plasma-input-font-style": "var(--plasma-typo-body-s-font-style)",
        "--plasma-input-font-weight": "var(--plasma-typo-body-s-bold-font-weight)",
        "--plasma-input-letter-spacing": "var(--plasma-typo-body-s-letter-spacing)",
        "--plasma-input-line-height": "var(--plasma-typo-body-s-line-height)",
        "--plasma-input-background-color": "var(--plasma-colors-surface-liquid01)",
        "--plasma-input-color": "var(--plasma-colors-primary)",
        "--plasma-input-caret-color": "var(--plasma-colors-primary)",
        "--plasma-input-placeholder-color": "var(--plasma-colors-secondary)",
        "--plasma-input-hover-background-color": "var(--plasma-colors-surface-liquid02)",
        "--plasma-input-focus-background-color": "var(--plasma-colors-surface-liquid02)",
        "--plasma-input-success-background-color": "var(--plasma-colors-background)",
        "--plasma-input-success-color": "var(--plasma-colors-primary)",
        "--plasma-input-success-border-color": "var(--plasma-colors-success)",
        "--plasma-input-warning-background-color": "var(--plasma-colors-background)",
        "--plasma-input-warning-color": "var(--plasma-colors-primary)",
        "--plasma-input-warning-border-color": "var(--plasma-colors-warning)",
        "--plasma-input-error-background-color": "var(--plasma-colors-input-error-background)",
        "--plasma-input-error-color": "var(--plasma-colors-critical)",
        "--plasma-input-error-border-color": "var(--plasma-colors-input-error-border)",
        "--plasma-input-focus-placeholder-color": "var(--plasma-colors-tertiary)",
        "--plasma-input-label-margin-top": "0.4375rem",
        "--plasma-input-label-font-family": "var(--plasma-typo-body-xxs-font-family)",
        "--plasma-input-label-font-size": "var(--plasma-typo-body-xxs-font-size)",
        "--plasma-input-label-font-style": "var(--plasma-typo-body-xxs-font-style)",
        "--plasma-input-label-font-weight": "var(--plasma-typo-body-xxs-bold-font-weight)",
        "--plasma-input-label-letter-spacing": "var(--plasma-typo-body-xxs-letter-spacing)",
        "--plasma-input-label-line-height": "var(--plasma-typo-body-xxs-line-height)",
        "--plasma-input-label-color": "var(--plasma-colors-tertiary)",
        "--plasma-field-font-family": "var(--plasma-typo-body-s-font-family)",
        "--plasma-field-font-size": "var(--plasma-typo-body-s-font-size)",
        "--plasma-field-font-style": "var(--plasma-typo-body-s-font-style)",
        "--plasma-field-font-weight": "var(--plasma-typo-body-s-bold-font-weight)",
        "--plasma-field-letter-spacing": "var(--plasma-typo-body-s-letter-spacing)",
        "--plasma-field-line-height": "var(--plasma-typo-body-s-line-height)",
        "--plasma-field-color": "var(--plasma-colors-secondary)",
        "--plasma-field-success-color": "var(--plasma-colors-success)",
        "--plasma-field-warning-color": "var(--plasma-colors-warning)",
        "--plasma-field-error-color": "var(--plasma-colors-critical)",
        "--text-primary-hover": "#FFFFFF93",
        "--text-primary-active": "#FFFFFFC4",
        "--text-primary": "rgba(255, 255, 255, 0.96)",
        "--text-primary-brightness": "#FFFFFF",
        "--text-secondary-hover": "#FFFFFFFF",
        "--text-secondary-active": "#FFFFFFAB",
        "--text-secondary": "rgba(255, 255, 255, 0.56)",
        "--text-tertiary-hover": "#FFFFFFFF",
        "--text-tertiary-active": "#FFFFFF56",
        "--text-tertiary": "rgba(255, 255, 255, 0.28)",
        "--text-paragraph-hover": "#FFFFFF7A",
        "--text-paragraph-active": "#FFFFFFA3",
        "--text-paragraph": "rgba(255, 255, 255, 0.8)",
        "--text-accent-hover": "#90B6FEFF",
        "--text-accent-active": "#216EFDFF",
        "--text-accent": "#3F81FD",
        "--text-accent-gradient-hover": "#CCCCCCFF",
        "--text-accent-gradient-active": "#E6E6E6FF",
        "--text-accent-gradient": "linear-gradient(89.83deg, #5E94FF 0%, #43DBFA 100%)",
        "--text-positive-hover": "#1EB83AFF",
        "--text-positive-active": "#15842AFF",
        "--text-positive": "#1A9E32",
        "--text-warning-hover": "#FB7223FF",
        "--text-warning-active": "#DC5304FF",
        "--text-warning": "#FA5F05",
        "--text-negative-hover": "#FF475AFF",
        "--text-negative-active": "#FF0A23FF",
        "--text-negative": "#FF293E",
        "--on-dark-text-primary-hover": "#FFFFFF93",
        "--on-dark-text-primary-active": "#FFFFFFC4",
        "--on-dark-text-primary": "rgba(255, 255, 255, 0.96)",
        "--on-dark-text-primary-brightness": "#FFFFFF",
        "--on-dark-text-secondary-hover": "#FFFFFFFF",
        "--on-dark-text-secondary-active": "#FFFFFFAB",
        "--on-dark-text-secondary": "rgba(255, 255, 255, 0.56)",
        "--on-dark-text-tertiary-hover": "#FFFFFFFF",
        "--on-dark-text-tertiary-active": "#FFFFFF56",
        "--on-dark-text-tertiary": "rgba(255, 255, 255, 0.28)",
        "--on-dark-text-paragraph-hover": "#FFFFFF7A",
        "--on-dark-text-paragraph-active": "#FFFFFFA3",
        "--on-dark-text-paragraph": "rgba(255, 255, 255, 0.8)",
        "--on-dark-text-accent-hover": "#90B6FEFF",
        "--on-dark-text-accent-active": "#216EFDFF",
        "--on-dark-text-accent": "#3F81FD",
        "--on-dark-text-accent-gradient-hover": "#CCCCCCFF",
        "--on-dark-text-accent-gradient-active": "#E6E6E6FF",
        "--on-dark-text-accent-gradient": "linear-gradient(89.83deg, #5E94FF 0%, #43DBFA 100%)",
        "--on-dark-text-positive-hover": "#1EB83AFF",
        "--on-dark-text-positive-active": "#15842AFF",
        "--on-dark-text-positive": "#1A9E32",
        "--on-dark-text-warning-hover": "#FB7223FF",
        "--on-dark-text-warning-active": "#DC5304FF",
        "--on-dark-text-warning": "#FA5F05",
        "--on-dark-text-negative-hover": "#FF475AFF",
        "--on-dark-text-negative-active": "#FF0A23FF",
        "--on-dark-text-negative": "#FF293E",
        "--on-light-text-primary-hover": "#08080893",
        "--on-light-text-primary-active": "#080808C4",
        "--on-light-text-primary": "rgba(8, 8, 8, 0.96)",
        "--on-light-text-primary-brightness": "#171717",
        "--on-light-text-secondary-hover": "#080808FF",
        "--on-light-text-secondary-active": "#080808AB",
        "--on-light-text-secondary": "rgba(8, 8, 8, 0.56)",
        "--on-light-text-tertiary-hover": "#080808FF",
        "--on-light-text-tertiary-active": "#08080856",
        "--on-light-text-tertiary": "rgba(8, 8, 8, 0.28)",
        "--on-light-text-paragraph-hover": "#0808087A",
        "--on-light-text-paragraph-active": "#080808A3",
        "--on-light-text-paragraph": "rgba(8, 8, 8, 0.8)",
        "--on-light-text-accent-hover": "#79A7FBFF",
        "--on-light-text-accent-active": "#0D5FF8FF",
        "--on-light-text-accent": "#2A72F8",
        "--on-light-text-accent-gradient-hover": "#CCCCCCFF",
        "--on-light-text-accent-gradient-active": "#E6E6E6FF",
        "--on-light-text-accent-gradient": "linear-gradient(93.97deg, #3E79F0 6.49%, #27C6E5 93.51%)",
        "--on-light-text-positive-hover": "#1EB83AFF",
        "--on-light-text-positive-active": "#15842AFF",
        "--on-light-text-positive": "#1A9E32",
        "--on-light-text-warning-hover": "#FB7223FF",
        "--on-light-text-warning-active": "#DC5304FF",
        "--on-light-text-warning": "#FA5F05",
        "--on-light-text-negative-hover": "#F5384BFF",
        "--on-light-text-negative-active": "#E40C22FF",
        "--on-light-text-negative": "#F31B31",
        "--inverse-text-primary-hover": "#08080893",
        "--inverse-text-primary-active": "#080808C4",
        "--inverse-text-primary": "rgba(8, 8, 8, 0.96)",
        "--inverse-text-primary-brightness": "#171717",
        "--inverse-text-secondary-hover": "#080808FF",
        "--inverse-text-secondary-active": "#080808AB",
        "--inverse-text-secondary": "rgba(8, 8, 8, 0.56)",
        "--inverse-text-tertiary-hover": "#080808FF",
        "--inverse-text-tertiary-active": "#08080856",
        "--inverse-text-tertiary": "rgba(8, 8, 8, 0.28)",
        "--inverse-text-paragraph-hover": "#0808087A",
        "--inverse-text-paragraph-active": "#080808A3",
        "--inverse-text-paragraph": "rgba(8, 8, 8, 0.8)",
        "--surface-solid-primary-hover": "#1C1C1CFF",
        "--surface-solid-primary-active": "#121212FF",
        "--surface-solid-primary": "#171717",
        "--surface-solid-primary-brightness": "#252525",
        "--surface-solid-secondary-hover": "#303030FF",
        "--surface-solid-secondary-active": "#212121FF",
        "--surface-solid-secondary": "#262626",
        "--surface-solid-tertiary-hover": "#404040FF",
        "--surface-solid-tertiary-active": "#303030FF",
        "--surface-solid-tertiary": "#363636",
        "--surface-solid-card-hover": "#1C1C1CFF",
        "--surface-solid-card-active": "#121212FF",
        "--surface-solid-card": "#171717",
        "--surface-solid-card-brightness": "#252525",
        "--surface-solid-default-hover": "#FFFFFFFF",
        "--surface-solid-default-active": "#FFFFFFFF",
        "--surface-solid-default": "rgba(255, 255, 255, 1)",
        "--surface-transparent-primary-hover": "#FFFFFF1F",
        "--surface-transparent-primary-active": "#FFFFFF0A",
        "--surface-transparent-primary": "rgba(255, 255, 255, 0.06)",
        "--surface-transparent-secondary-hover": "#FFFFFF3D",
        "--surface-transparent-secondary-active": "#FFFFFF0F",
        "--surface-transparent-secondary": "rgba(255, 255, 255, 0.12)",
        "--surface-transparent-tertiary-hover": "#FFFFFF52",
        "--surface-transparent-tertiary-active": "#FFFFFF24",
        "--surface-transparent-tertiary": "rgba(255, 255, 255, 0.2)",
        "--surface-transparent-deep-hover": "#FFFFFFC2",
        "--surface-transparent-deep-active": "#FFFFFF94",
        "--surface-transparent-deep": "rgba(255, 255, 255, 0.64)",
        "--surface-transparent-card-hover": "#FFFFFF3D",
        "--surface-transparent-card-active": "#FFFFFF0F",
        "--surface-transparent-card": "rgba(255, 255, 255, 0.12)",
        "--surface-transparent-card-brightness": "#FFFFFF",
        "--surface-clear-hover": "#FFFFFF00",
        "--surface-clear-active": "#FFFFFF00",
        "--surface-clear": "rgba(255, 255, 255, 0)",
        "--surface-accent-hover": "#5D95FDFF",
        "--surface-accent-active": "#357BFDFF",
        "--surface-accent": "#3F81FD",
        "--surface-accent-gradient-hover": "#FFFFFFFF",
        "--surface-accent-gradient-active": "#FFFFFFFF",
        "--surface-accent-gradient": "linear-gradient(93.97deg, #3E79F0 6.49%, #27C6E5 93.51%), linear-gradient(89.83deg, #5E94FF 0%, #43DBFA 100%)",
        "--surface-transparent-accent-hover": "#3F82FD3D",
        "--surface-transparent-accent-active": "#3F82FD0F",
        "--surface-positive-hover": "#1DAF37FF",
        "--surface-positive-active": "#18952FFF",
        "--surface-positive": "#1A9E32",
        "--surface-warning-hover": "#FB7223FF",
        "--surface-warning-active": "#F05B05FF",
        "--surface-warning": "#FA5F05",
        "--surface-negative-hover": "#FF475AFF",
        "--surface-negative-active": "#FF1F35FF",
        "--surface-negative": "#FF293E",
        "--surface-transparent-positive-hover": "#1A9E323D",
        "--surface-transparent-positive-active": "#1A9E320F",
        "--surface-transparent-warning-hover": "#FA5F053D",
        "--surface-transparent-warning-active": "#FA5F050F",
        "--surface-transparent-negative-hover": "#FF293E3D",
        "--surface-transparent-negative-active": "#FF293E0F",
        "--surface-transparent-accent": "rgba(63,129,253,0.12)",
        "--surface-transparent-positive": "rgba(26,158,50,0.12)",
        "--surface-transparent-warning": "rgba(250,95,5,0.12)",
        "--surface-transparent-negative": "rgba(255,41,62,0.12)",
        "--on-dark-surface-solid-primary-hover": "#1C1C1CFF",
        "--on-dark-surface-solid-primary-active": "#121212FF",
        "--on-dark-surface-solid-primary": "#171717",
        "--on-dark-surface-solid-primary-brightness": "#252525",
        "--on-dark-surface-solid-secondary-hover": "#303030FF",
        "--on-dark-surface-solid-secondary-active": "#212121FF",
        "--on-dark-surface-solid-secondary": "#262626",
        "--on-dark-surface-solid-tertiary-hover": "#404040FF",
        "--on-dark-surface-solid-tertiary-active": "#303030FF",
        "--on-dark-surface-solid-tertiary": "#363636",
        "--on-dark-surface-solid-card-hover": "#1C1C1CFF",
        "--on-dark-surface-solid-card-active": "#121212FF",
        "--on-dark-surface-solid-card": "#171717",
        "--on-dark-surface-solid-card-brightness": "#252525",
        "--on-dark-surface-solid-default-hover": "#FFFFFFFF",
        "--on-dark-surface-solid-default-active": "#FFFFFFFF",
        "--on-dark-surface-solid-default": "rgba(255, 255, 255, 1)",
        "--on-dark-surface-transparent-primary-hover": "#FFFFFF1F",
        "--on-dark-surface-transparent-primary-active": "#FFFFFF0A",
        "--on-dark-surface-transparent-primary": "rgba(255, 255, 255, 0.06)",
        "--on-dark-surface-transparent-secondary-hover": "#FFFFFF3D",
        "--on-dark-surface-transparent-secondary-active": "#FFFFFF0F",
        "--on-dark-surface-transparent-secondary": "rgba(255, 255, 255, 0.12)",
        "--on-dark-surface-transparent-tertiary-hover": "#FFFFFF52",
        "--on-dark-surface-transparent-tertiary-active": "#FFFFFF24",
        "--on-dark-surface-transparent-tertiary": "rgba(255, 255, 255, 0.2)",
        "--on-dark-surface-transparent-deep-hover": "#FFFFFFC2",
        "--on-dark-surface-transparent-deep-active": "#FFFFFF94",
        "--on-dark-surface-transparent-deep": "rgba(255, 255, 255, 0.64)",
        "--on-dark-surface-transparent-card-hover": "#FFFFFF3D",
        "--on-dark-surface-transparent-card-active": "#FFFFFF0F",
        "--on-dark-surface-transparent-card": "rgba(255, 255, 255, 0.12)",
        "--on-dark-surface-transparent-card-brightness": "#FFFFFF",
        "--on-dark-surface-accent-hover": "#5D95FDFF",
        "--on-dark-surface-accent-active": "#357BFDFF",
        "--on-dark-surface-accent": "#3F81FD",
        "--on-dark-surface-accent-gradient-hover": "#FFFFFFFF",
        "--on-dark-surface-accent-gradient-active": "#FFFFFFFF",
        "--on-dark-surface-accent-gradient": "linear-gradient(93.97deg, #3E79F0 6.49%, #27C6E5 93.51%)",
        "--on-dark-surface-positive-hover": "#1DAF37FF",
        "--on-dark-surface-positive-active": "#18952FFF",
        "--on-dark-surface-positive": "#1A9E32",
        "--on-dark-surface-warning-hover": "#FB7223FF",
        "--on-dark-surface-warning-active": "#F05B05FF",
        "--on-dark-surface-warning": "#FA5F05",
        "--on-dark-surface-negative-hover": "#FF475AFF",
        "--on-dark-surface-negative-active": "#FF1F35FF",
        "--on-dark-surface-negative": "#FF293E",
        "--on-light-surface-solid-primary-hover": "#FAFAFAFF",
        "--on-light-surface-solid-primary-active": "#F0F0F0FF",
        "--on-light-surface-solid-primary": "#F5F5F5",
        "--on-light-surface-solid-primary-brightness": "#F6F6F6",
        "--on-light-surface-solid-secondary-hover": "#F7F7F7FF",
        "--on-light-surface-solid-secondary-active": "#E8E8E8FF",
        "--on-light-surface-solid-secondary": "#ECECEC",
        "--on-light-surface-solid-tertiary-hover": "#E8E8E8FF",
        "--on-light-surface-solid-tertiary-active": "#D9D9D9FF",
        "--on-light-surface-solid-tertiary": "#DDDDDD",
        "--on-light-surface-solid-card-hover": "#FFFFFFFF",
        "--on-light-surface-solid-card-active": "#FFFFFFFF",
        "--on-light-surface-solid-card": "rgba(255, 255, 255, 1)",
        "--on-light-surface-solid-card-brightness": "#FFFFFF",
        "--on-light-surface-solid-default-hover": "#0D0D0DFF",
        "--on-light-surface-solid-default-active": "#030303FF",
        "--on-light-surface-solid-default": "#080808",
        "--on-light-surface-transparent-primary-hover": "#08080812",
        "--on-light-surface-transparent-primary-active": "#08080803",
        "--on-light-surface-transparent-primary": "rgba(8, 8, 8, 0.03)",
        "--on-light-surface-transparent-secondary-hover": "#0808081F",
        "--on-light-surface-transparent-secondary-active": "#0808080A",
        "--on-light-surface-transparent-secondary": "rgba(8, 8, 8, 0.06)",
        "--on-light-surface-transparent-tertiary-hover": "#0808083D",
        "--on-light-surface-transparent-tertiary-active": "#0808080F",
        "--on-light-surface-transparent-tertiary": "rgba(8, 8, 8, 0.12)",
        "--on-light-surface-transparent-deep-hover": "#080808C2",
        "--on-light-surface-transparent-deep-active": "#08080894",
        "--on-light-surface-transparent-deep": "rgba(8, 8, 8, 0.64)",
        "--on-light-surface-transparent-card-hover": "#FFFFFFFF",
        "--on-light-surface-transparent-card-active": "#FFFFFFFF",
        "--on-light-surface-transparent-card": "rgba(255, 255, 255, 1)",
        "--on-light-surface-transparent-card-brightness": "#FFFFFF",
        "--on-light-surface-accent-hover": "#4886F9FF",
        "--on-light-surface-accent-active": "#206CF8FF",
        "--on-light-surface-accent": "#2A72F8",
        "--on-light-surface-accent-gradient-hover": "#FFFFFFFF",
        "--on-light-surface-accent-gradient-active": "#FFFFFFFF",
        "--on-light-surface-accent-gradient": "linear-gradient(93.97deg, #3E79F0 6.49%, #27C6E5 93.51%)",
        "--on-light-surface-positive-hover": "#1DAF37FF",
        "--on-light-surface-positive-active": "#18952FFF",
        "--on-light-surface-positive": "#1A9E32",
        "--on-light-surface-warning-hover": "#FB7223FF",
        "--on-light-surface-warning-active": "#F05B05FF",
        "--on-light-surface-warning": "#FA5F05",
        "--on-light-surface-negative-hover": "#F5384BFF",
        "--on-light-surface-negative-active": "#F31228FF",
        "--on-light-surface-negative": "#F31B31",
        "--background-primary": "#080808",
        "--background-primary-brightness": "#171717",
        "--dark-background-primary": "#080808",
        "--light-background-primary": "#F9F9F9",
        "--overlay-soft": "rgba(8, 8, 8, 0.56)",
        "--overlay-hard": "rgba(8, 8, 8, 0.96)",
        "--overlay-blur": "rgba(8, 8, 8, 0.28)",
        "--on-dark-overlay-soft": "rgba(8, 8, 8, 0.56)",
        "--on-dark-overlay-hard": "rgba(8, 8, 8, 0.96)",
        "--on-dark-overlay-blur": "rgba(8, 8, 8, 0.28)",
        "--on-light-overlay-soft": "rgba(249, 249, 249, 0.56)",
        "--on-light-overlay-hard": "rgba(249, 249, 249, 0.96)",
        "--on-light-overlay-blur": "rgba(249, 249, 249, 0.28)",
        "--skeleton-gradient": "linear-gradient( 90deg, rgba(255, 255, 255, 0.09) 0%, rgba(255, 255, 255, 0.08) 6.25%, rgba(255, 255, 255, 0.05) 12.5%, rgba(255, 255, 255, 0.01) 25%, rgba(255, 255, 255, 0.05) 37.5%, rgba(255, 255, 255, 0.08) 43.75%, rgba(255, 255, 255, 0.09) 50%, rgba(255, 255, 255, 0.08) 56.25%, rgba(255, 255, 255, 0.05) 62.5%, rgba(255, 255, 255, 0.01) 75%, rgba(255, 255, 255, 0.05) 87.5%, rgba(255, 255, 255, 0.08) 93.75%, rgba(255, 255, 255, 0.09) 100% )",
        "--skeleton-gradient-lighter": "linear-gradient( 90deg, rgba(255, 255, 255, 0.36) 0%, rgba(255, 255, 255, 0.32) 6.25%, rgba(255, 255, 255, 0.20) 12.5%, rgba(255, 255, 255, 0.04) 25%, rgba(255, 255, 255, 0.20) 37.5%, rgba(255, 255, 255, 0.32) 43.75%, rgba(255, 255, 255, 0.36) 50%, rgba(255, 255, 255, 0.08) 56.25%, rgba(255, 255, 255, 0.20) 62.5%, rgba(255, 255, 255, 0.04) 75%, rgba(255, 255, 255, 0.20) 87.5%, rgba(255, 255, 255, 0.32) 93.75%, rgba(255, 255, 255, 0.36) 100% )",
        "--outline-solid-secondary": "#4E4E4E",
        "--outline-solid-secondary-hover": "#595959FF",
        "--outline-accent": "#3F81FD",
        "--text-info": "#3F81FD",
        "--surface-transparent-info": "#3F81FD33",
        "color": "rgba(255, 255, 255, 0.96)",
        "backgroundColor": "#080808"
    }
};
//# sourceMappingURL=dark.js.map